import React from 'react'

export const Title = (props) => {
    return (
        <>
            <div className="mid">
                <h5>{props.title}</h5>
            </div>
        </>
    )
}
